module.exports = __webpack_public_path__ + "img/paystack.e5830b68.png";